<!--
 * @Author: 陈梦男
 * @Date: 2024-05-22 14:44:21
 * @LastEditTime: 2024-12-27 15:49:45
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 报告数据管理
 * @FilePath: \web\src\components\ReportComponents\DataManager\index.vue
-->
<template>
  <section class="report-management">
    <section class="report-search-container">
      <SearchModule @submit="searchHandle" :countryList="countryList" :type="type" />
      <div class="crud-wrapper">
        <div class="crud-item" @click="add()">新增</div>
        <div class="crud-item" @click="selectDel()"
          :class="selectedKeys.length > 0 ? 'crud-item-abled' : 'crud-item-disabled'">
          删除
        </div>
        <!-- <div class="crud-item" @click="importData()">导入</div> -->

      </div>
    </section>
    <a-table rowKey="id" class="report-datamanager-table" :dataSource="tableData" :columns="columns"
      @change="changePage" :row-selection="rowSelection" :scroll="{ y: '90%' }" :pagination="paginationOption">
      <template #serial="{ index }">{{ index + 1 }}</template>
      <template #action="{ record, index }">
        <section class="action-icons">
          <span v-for="(item, i) in tableOperationList" :key="i">
            <i v-bind="item.option" :style="{
              color: 'rgb(255, 200, 120)'
            }" @click="item.click(record, index)">
            </i>
          </span>

        </section>
      </template>
    </a-table>

    <Modal :option="confirmModalConf" @confirm="confirm" @close="close">
      <template v-slot:main>
        <section class="detail-modal-container" v-if="confirmModalConf.type === 'edit'">
          <RecordEdit :headerInfo="detailHeaderConf" :code="recordCode" :formState="formState" ref="recordEditRef"
            :countryList="countryList" :mineList="mineList" :type="type" />
        </section>
      </template>
    </Modal>
    <!-- / 操作弹出框 -->
  </section>
</template>

<script setup>
import { ref, reactive, watch, onMounted, defineProps, } from 'vue';
import dayjs from 'dayjs';
import { message, } from 'ant-design-vue';
import SearchModule from './search.vue';
import { tableConfig, tableConfigGb, tableConfigKz, } from './tableConfig.js';
import Modal from '@/components/lib/Modal/modal1.vue';
import config from '@/config/config';
import {
  trendDataImport,
  trendDataDownApi,
} from '@/api/projectPerformance/dataManager.js';
import { getPageApi, updateApi, saveApi, deleteApi, } from '@/api/Portal/marketApi';

import { getMineralsApi, getCountryApi, } from '@/api/utils/utilsApi';
import RecordEdit from './edit.vue';
import { downLoadUtil, } from '@/components/utils/utils';

const props = defineProps({
  type: {
    type: String,
  },
});

const columns = ref(tableConfigGb);

const selectedKeys = ref([]); // 表格选中id
const countryList = ref([]);
const mineList = ref([]);
const paginationOption = reactive({
  total: 0,
  pageSize: 10,
  current: 1,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['6', '10', '20', '30', '40', '50',],
});

const tableData = ref('');
const requestParams = reactive({
  content: '',
  order: '',
  page: paginationOption.current,
  sidx: '',
  size: paginationOption.pageSizeRef,
  type: props.type,
});

let formState = ref({
  type: props.type,
  fileId: '',
  name: '',
  owner: '',
  reportDate: null,
  integral: 5,
  country: '',
  minerals: '',
  shows: 1,
});

// 确认弹窗 公用
const confirmModalConf = reactive({
  loading: false,
  visible: false,
  title: '',
  confirm: null,
  remark: '',
  callback: null,
  selectValue: [],
  type: '',
  notFooter: false, // 是否显示底部内容
  width: '5.4rem',
  fileList: [],
});

const recordCode = ref(''); // 表格数据编码

// 详情页矿种信息
const detailHeaderConf = reactive([
  {
    label: '矿种',
    value: '',
  },
  {
    label: '单位',
    value: '',
  },
]);


/**
 * 获取国家列表
 */
const getCountryList = () => {
  getCountryApi({ id: '', }).then((res) => {
    // 请求大洲 清空选中的值
    if (res.code === 200) {
      // countryList.value = res.data.data;
      countryList.value = res.data.map((item) => ({ ...item, value: item.countryName, label: item.countryName, }));
    }
  });
};
/**
 * 获取矿种列表
 */
const getMineList = () => {
  getMineralsApi().then((res) => {
    let list = res.data;

    mineList.value = res.data.map((item) => ({ ...item, value: item.name, label: item.name, }));
  });
};
const getTableDate = () => {
  getPageApi(requestParams).then((res) => {
    const list = res.data.list;

    list.forEach((item) => {
      // 后端不愿意修改，所以前端自己截取
      if (item.reportFile && item.reportFile.url) {
        const arr = item.reportFile.url.split('/');

        item.fileName = arr[arr.length - 1];
      }
    });
    paginationOption.total = res.data.totalCount;
    tableData.value = list;
  });
};
/**
 * @description 查询
 */
const searchHandle = (params) => {
  const { name = null, country = null, minerals = null, timeRange = null, } = params;

  requestParams.page = 1;
  requestParams.size = 10;
  paginationOption.current = 1;
  paginationOption.pageSize = 10;
  requestParams.name = name;
  requestParams.country = country;
  requestParams.minerals = minerals;
  if (timeRange && timeRange.length === 2) {
    requestParams.startDate = dayjs(timeRange[0]).format('YYYY-MM-DD');
    requestParams.endDate = dayjs(timeRange[1]).format('YYYY-MM-DD');
  } else {
    requestParams.startDate = null;
    requestParams.endDate = null;

  }
  getTableDate();
};

// -------------------- 删除
// 开始删除
const delInfo = (ids) => {
  deleteApi(ids).then((res) => {
    confirmModalConf.visible = false;
    message.success('删除成功！');
    searchHandle({});
  });
};
// 单行数据删除之前
const beforeDel = (ids) => {
  confirmModalConf.title = `确认删除${ids.length}份报告？`;
  confirmModalConf.callback = () => delInfo(ids);
  confirmModalConf.visible = true;
};
// 单行删除
const delRecord = (record) => {
  const { id, } = record;

  beforeDel([id,]);
};
/**
 * @description 勾选删除
 */
const selectDel = () => {
  const ids = selectedKeys.value;

  beforeDel(ids);
};

// -------------------- 导出
// 开始导出
const downloadInfo = (ids, codes) => {
  trendDataDownApi({ code: codes.join(','), ids: ids.join(','), sort: '', }).then((res) => {
    downLoadUtil(res).then(() => { });
    confirmModalConf.visible = false;
    // 下载接口调用成功
  });
};
// 单行数据下载之前
const beforeDownload = (ids, codes) => {
  confirmModalConf.title = '导出数据';
  confirmModalConf.callback = () => downloadInfo(ids, codes);
  confirmModalConf.visible = true;
  confirmModalConf.type = 'download';
  confirmModalConf.width = '7rem';
};
// 单行数据下载
const downloadRecord = (record, index) => {
  const { id, code, } = record;

  beforeDownload([id,], [code,]);
};


const tableOperationList = ref([]);

// 新增 删除的权限控制
const operationConf = [1, 2,];

/**
 * @description 表格选中事件
 */
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    selectedKeys.value = selectedRowKeys;
  },
};

/**
 * @description 关闭通用弹窗
 */
const close = () => {
  confirmModalConf.visible = false;
  confirmModalConf.notFooter = false;
  confirmModalConf.title = '';
  confirmModalConf.type = '';
  confirmModalConf.width = '5.4rem';
  formState.value.type = props.type;
  formState.value.fileId = '';
  formState.value.name = '';
  formState.value.owner = '';
  formState.value.reportDate = null;
  formState.value.integral = 5;
  formState.value.country = '';
  formState.value.minerals = '';
  formState.value.shows = 1;
  formState.value.fileName = '';
  formState.value.reportFile = {};
};
/**
 *
 * @param {*} record 预编辑数据信息
 */
const setUpdateApi = (params) => {
  updateApi(params).then((res) => {
    if (res.code === 200 && res.data.code === 200) {
      message.success('保存成功！');
      close();
      searchHandle({});
    }
  });
};
// 编辑确认
const recordEditRef = ref();

const submitEdit = () => {
  recordEditRef.value.formRef.validate().then(() => {
    const { id, type, fileId, name, owner, reportDate, integral, country, minerals, shows, } = recordEditRef.value.formData
    const reportDate1 = dayjs(reportDate).format('YYYY-MM');
    const params = [{
      id, type, fileId, name, owner, reportDate: reportDate1, integral, country, minerals, shows,
    }];

    setUpdateApi(params);
  })
    .catch((error) => {
      console.log('error', error);
    });
};

const submitAdd = () => {
  recordEditRef.value.formRef
    .validate()
    .then(() => {
      const { type, fileId, name, owner, reportDate, integral, country, minerals, shows, } = formState.value
      const reportDate1 = dayjs(reportDate).format('YYYY-MM');
      const params = {
        type, fileId, name, owner, reportDate: reportDate1, integral, country, minerals, shows,
      };

      saveApi(params).then((res) => {
        if (res.code === 200 && res.data.code === 200) {
          message.success('保存成功！');
          close();
          searchHandle({});
        }
      });

    })
    .catch((error) => {
      console.log('error', error);
    });
};
const editRecord = (record) => {
  formState.value = JSON.parse(JSON.stringify(record));
  confirmModalConf.title = '编辑';
  confirmModalConf.callback = () => submitEdit();
  confirmModalConf.visible = true;
  confirmModalConf.type = 'edit';
  confirmModalConf.width = '5rem';
};

/**
 * @description 新增
 */
const add = () => {
  confirmModalConf.title = '新增';
  confirmModalConf.callback = () => submitAdd();
  confirmModalConf.visible = true;
  confirmModalConf.type = 'edit';
  confirmModalConf.width = '5rem';
};

/**
 * @description 页码change事件
 */
const changePage = (page) => {
  requestParams.page = page.current;
  requestParams.size = page.pageSize;
  paginationOption.current = page.current;
  paginationOption.pageSize = page.pageSize;
  getTableDate();
};

/**
 * @description 确认通用弹窗
 */
const confirm = () => {
  confirmModalConf.callback();
};

// 操作的权限
const tableOperationListConf = [
  // {
  //   option: {
  //     style: 'color: rgb(255, 200, 120)',
  //     class: 'iconfont icon-show',
  //     title: '页面展示',
  //   },
  //   click: showRecord,
  //   operation: [1, 2,],
  // },
  // {
  //   option: {
  //     style: 'color: rgb(255, 200, 120)',
  //     class: 'iconfont icon-no-show',
  //     title: '取消展示',
  //   },
  //   click: noShowRecord,
  //   operation: [1, 2,],
  // },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-bianjishuru',
      title: '编辑',
    },
    click: editRecord,
    operation: [1, 2,],
  },
  {
    option: {
      style: 'color: rgb(255, 200, 120)',
      class: 'iconfont icon-shanchu',
      title: '删除',
    },
    click: delRecord,
    operation: [1, 2,],
  },
];

onMounted(() => {
  tableOperationList.value = tableOperationListConf;
  getCountryList();
  getMineList();
  getTableDate();
});

watch(() => props.type,
  (val) => {
    if (val) {
      columns.value = val === '国别报告' ? tableConfigGb : val === '矿种报告' ? tableConfigKz : tableConfig;
    }
  }, {
  immediate: true,
  deep: true,
});
</script>

<style lang="scss">
.report-management {
  color: #fff;
  height: 100%;

  /* 检索条件 */
  .report-search-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 0.1rem;
    height: 0.5rem;
    margin-bottom: 0.1rem;

    .crud-wrapper {
      display: flex;
      height: 0.51rem;
      padding: 0.13rem 0.1rem;

      .crud-item {
        margin-right: 0.04rem;
        width: 0.5rem;
        color: #fff;
        // background-color: #efb227;
        background-image: url(~@/static/images/dataManagement/curd_btn.png);
        background-size: 100% 100%;
        text-align: center;
      }

      .crud-item:hover {
        cursor: pointer;
      }

      .crud-item-disabled {
        pointer-events: none;
        color: rgba(255, 255, 255, 0.6);
        // background-color: rgba(239, 178, 39, 0.6);
        opacity: 0.8;
      }

      .crud-item-disabled:hover {
        cursor: no-drop;
      }
    }
  }

  /* 表格样式 */
  .report-datamanager-table {
    height: calc(100% - 0.6rem);

    .ant-spin-container {
      display: flex;
      flex-direction: column;
      align-items: end;
    }

    .ant-spin-nested-loading,
    .ant-spin-container,
    .ant-table-content {
      height: 100%;
    }

    .ant-table {
      height: calc(100% - .50rem);
      background: none;
      padding-left: 0.1rem;

      .ant-table-scroll {
        height: 100%;
        overflow: visible;
        overflow-x: visible;

        .ant-table-header {
          overflow: visible !important;
          margin-bottom: 0 !important;
        }
      }

      .ant-table-header {
        background: none;
      }

      .ant-table-body {
        overflow-x: hidden !important;
        overflow-y: auto !important;
        background: none;
      }

      /* 矿种 */
      .primary-commodity-img {
        width: 0.8rem;
        height: 0.6rem;
      }

      /* 图标 */
      .action-icons {
        display: flex;
        align-items: center;
        gap: 0.05rem;

        i {
          display: inline-block;
          font-size: 0.22rem;
          margin-right: 0.04rem;
          cursor: pointer;
        }

        .icon-show {
          width: .2rem;
          height: .2rem;
          background-image: url(~@/static/images/report/icon_show.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;

        }

        .icon-no-show {
          width: .2rem;
          height: .2rem;
          background-image: url(~@/static/images/report/icon_no_show.png);
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }

      .ant-table-thead {
        border: .01rem solid #4d3f1c;
        border-radius: .10rem .10rem 0rem 0rem;
        background: none;
      }

      .ant-table-thead>tr>th {
        color: #ffc44d;
        background: rgba(179, 150, 92, 0.2);
        border: none;
      }

      .ant-table-tbody>tr>td {
        background-color: transparent;
        color: #fff;
        border-bottom: .01rem solid rgba(179, 150, 92, 1);
        vertical-align: middle;
      }

      .ant-table-placeholder {
        height: 100%;
        background-color: rgba(77, 63, 28, 1);
        border-top: rgba(179, 150, 92, 1);
        border-bottom: rgba(179, 150, 92, 1);
      }

      .ant-empty-normal {
        color: rgba(179, 150, 92, 1);
      }

      // 暂无数据填充样式
      // .ant-empty-img-simple-path {
      //   fill: rgba(77, 63, 28, 1);
      // }
      // .ant-empty-img-simple-ellipse {
      //   fill: rgba(77, 63, 28, 1);
      // }
      .ant-table-thead>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-thead>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td,
      .ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-thead>tr:hover.ant-table-row-selected>td,
      .ant-table-tbody>tr:hover.ant-table-row-selected>td {
        background-color: rgba(179, 150, 92, 0.6);
      }

      .ant-table-tbody>tr.ant-table-row-selected td {
        background-color: rgba(77, 63, 28, 1);
        color: #fff;
      }
    }


  }
}
</style>
